<template>
  <b-card class="form-builder-card" title="در این قسمت می توانید محتوا مورد نظر  را اضافه کنید">
    <b-row>
      <b-col cols="6">
        <!-- category name-->
        <b-form-group
            label="عنوان محتوا (اجباری)"
            label-for="v-content-title"
        >
          <b-form-input
              id="v-content-title"
              placeholder="عنوان محتوا را وارد کنید"
              v-model="title"
          />
        </b-form-group>


        <b-form-group
            label="عنوان نمایشی (اجباری)"
            label-for="v-content-title"
        >
          <b-form-input
              placeholder="عنوان نمایشی را وارد کنید"
              v-model="showName"
          />
        </b-form-group>



      </b-col>
      <b-col cols="6">
        <!-- category name-->

        <b-form-group
            label="انتخاب دسته محتوا (اجباری)"
            label-for="mother-categories"
        >
          <b-form-select
              id="mother-categories"
              v-model="selectedCategory"
              :options="categories"
              @change="checkCategory"

          />
        </b-form-group>


<span v-if="showOtherOptions === 1">
    <b-form-group
        label="بازه زمانی"
        label-for="mother-categories"
    >
          <b-form-select
              id="date"
              v-model="selectedDate"
              :options="Dates"

          />
        </b-form-group>

        <b-form-group
            label="زمان"
            label-for="mother-categories"
        >
          <b-form-input
              id="howManyTime"
              v-model="selectedTime"
              type="number"
              placeholder="لطفا مدت زمان را وارد کنید"
          />
        </b-form-group>
</span>

<span v-else-if="showOtherOptions === 2">
<!--  <b-form-group-->
<!--      label="محتوا برای"-->
<!--      label-for="mother-categories"-->
<!--  >-->
<!--          <b-form-select-->
<!--              id="babyContentType"-->
<!--              v-model="selectedBabyType"-->
<!--              :options="ContentBabyType"-->

<!--          />-->
<!--        </b-form-group>-->


          <b-form-group
              label="از مدت زمان (روز)"
              label-for="howManyTime1"
          >
          <b-form-input
              id="howManyTime1"
              v-model="fromTime"
              type="number"
          />
        </b-form-group>

  <b-form-group
      label="تا مدت زمان (روز)"
      label-for="howManyTime2"
  >
          <b-form-input
              id="howManyTime2"
              v-model="toTime"
              type="number"
          />
        </b-form-group>

</span>






        <b-form-group v-if="showOtherOptions !== 2 & showOtherOptions !==1"
            label="برای تب ها"
            label-for="v-content-title"
        >
          <b-form-radio
              v-model="forTab"
              plain
              name="some-radios3"
              :value="true"
          >
            برای تب
          </b-form-radio>
          <b-form-radio
              v-model="forTab"
              plain
              name="some-radios3"
              :value="false"
          >
            محتوا
          </b-form-radio>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col cols="4">
        <!-- draggable -->
        <draggable
            v-model="list"
            class="list-group list-group-flush cursor-move"
            tag="ul"
        >
          <transition-group
              type="transition"
              name="flip-list"
          >
            <b-list-group-item
                v-for="(listItem , index) in list"
                :key="listItem.name"
                style="min-height: 61px !important;"
                tag="li"
            >
              <div class="d-flex" style="position: relative">
                <feather-icon
                    :icon="icons[listItem.type]"
                    size="24"
                />
                <div class="ml-25">
                  <b-card-text class="font-weight-bold mb-1">
                    {{ listItem.name  }}
                  </b-card-text>
                </div>

                <div style="position: absolute ; left :25px">
                  <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-danger"
                      @click="removeItem(index)"
                  >
                    <feather-icon
                        icon="XIcon"
                        class="mr-15"
                    />
                    <span>حذف</span>
                  </b-button>
                </div>
              </div>
            </b-list-group-item>
          </transition-group>
        </draggable>
        <div style="height: 50%" v-if="list[0]">
            <span>

            </span>
        </div>
      </b-col>
      <b-col cols="8">
        <!--dropdown-->
        <b-dropdown
            text="اضافه کردن محتوا"
            variant="gradient-success"
        >
          <b-dropdown-item v-for="item of contentTypes" v-bind:key="item.id" @click="addSection(item.id)">
            {{ item.type }}
          </b-dropdown-item>

          <b-dropdown-divider/>
        </b-dropdown>
        <text-form-component  @shortTextSubmit="shortTextSubmit"
                             v-if="id === 0"></text-form-component>
        <long-text-form-component  @longTextSubmit="longTextSubmit"
                                  v-if="id === 1"></long-text-form-component>
        <image-form-component  @imageFormSubmit="imageFormSubmit"
                              v-if="id === 2"></image-form-component>
        <voice-form-component  @voiceFormSubmit="voiceFormSubmit"
                              v-if="id === 3"></voice-form-component>
        <video-form-component  @videoFormSubmit="videoFormSubmit"
                              v-if="id === 4"></video-form-component>
        <exam-form-component  @examFormSubmit="examFormSubmit"
                             v-if="id === 5"></exam-form-component>
        <poll-form-component  @pollFormSubmit="pollFormSubmit"
                             v-if="id === 6"></poll-form-component>
        <slider-form-component  @sliderFormSubmit="sliderFormSubmit"
                               v-if="id === 7"></slider-form-component>
        <tab-form-component  @tapFormSubmit="tapFormSubmit" v-if="id === 8"></tab-form-component>
      </b-col>
    </b-row>
    <b-row class="mt-6" v-if="list.length > 0" style="margin-top: 100px">
      <b-col md="4">
        <div class="demo-inline-spacing">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              block
              variant="success"
              @click="addContent"
          >
            ذخیره محتوا
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>

import {
  BListGroupItem,
  BCardText,
  BFormGroup,
  BButton,
  BAvatar,
  BFormSelect,
  BFormInput,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BFormRadio,
  BCard
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import voiceFormComponent from "@/modules/contents/add/voiceFormComponent";
import examFormComponent from "@/modules/contents/add/examFormComponent";
import imageFormComponent from "@/modules/contents/add/imageFormComponent";
import longTextComponent from "@/modules/contents/add/longTextFormComponent";
import sliderFormComponent from "@/modules/contents/add/sliderFormComponent";
import tabFormComponent from "@/modules/contents/add/tabFormComponent";
import videoFormComponent from "@/modules/contents/add/videoFormComponent";
import TextFormComponent from "@/modules/contents/add/textFormComponent";
import LongTextFormComponent from "@/modules/contents/add/longTextFormComponent";
import PollFormComponent from "@/modules/contents/add/longTextFormComponent";
import pollFormComponent from "@/modules/contents/add/pollFormComponent";
import categoryRepository from "@/modules/categories/services/categoryRepository";
import Swal from "sweetalert2";
import contentRepository from "@/modules/contents/services/contentRepository";
import Ripple from "vue-ripple-directive";

export default {
  name: "contentBuilder",
  components: {
    PollFormComponent,
    BCardText,
    LongTextFormComponent,
    TextFormComponent,
    BRow,
    BCol,
    BFormRadio,
    BCard,
    BFormGroup,
    BButton, draggable,
    BListGroupItem,
    BAvatar,
    Prism,
    BDropdown,
    BFormSelect, BFormInput,
    BDropdownDivider,
    BDropdownItem,
    voiceFormComponent,
    examFormComponent,
    imageFormComponent,
    longTextComponent,
    sliderFormComponent,
    pollFormComponent,
    tabFormComponent,
    videoFormComponent,

  },
  data() {
    return {
      categories: [],
      selectedCategory: null,
      showOtherOptions:undefined,
      title: undefined,
      showName: undefined,
      forTab: false,
      toTime:0,
      fromTime:0,
      id: undefined,
      list: [],
      Dates:[
        {
          value: 1,
          text: ' روزانه'
        },
        {
          value: 2,
          text: 'هفتگی'
        },
        {
          value: 3,
          text: 'ماهانه'
        },
      ],
      selectedBabyType :undefined,
      selectedDate :undefined,
      ContentBabyType:[
        {
          value: 1,
          text: 'روز تولد'
        },
        {
          value: 2,
          text: 'روز هفتم'
        },
        {
          value: 3,
          text: 'سه سالگی'
        },
        {
          value: 4,
          text: 'سه سال و هفت ماهگی'
        },
        {
          value: 5,
          text: 'چهارسالگی'
        },
        {
          value: 6,
          text: 'پنج سالگی'
        },
        {
          value: 7,
          text: 'شش سالگی'
        },
        {
          value: 8,
          text: 'هفت سالگی'
        },
        {
          value: 9,
          text: 'نه سالگی'
        },
      ],
      contentTypes: [
        {
          type: 'متن',
          engType:'shortText',
          id: 0,
        },
        {
          type: 'متن بلند',
          engType:'longText',
          id: 1,
        },
        {
          type: 'عکس',
          engType:'image',
          id: 2,
        },
        {
          type: 'ویس',
          engType:'voice',
          id: 3,
        },
        {
          type: 'ویدیو',
          engType:'video',
          id: 4,
        },
        {
          type: 'آزمون',
          engType:'exam',
          id: 5,
        },
        {
          type: 'نظر سنجی',
          engType:'poll',
          id: 6,
        },
        {
          type: 'اسلایدر',
          engType:'slider',
          id: 7,
        },
        {
          type: 'تب',
          engType:'tab',
          id: 8,
        }
      ],
      icons: {
        0: "TypeIcon",
        1: "MenuIcon",
        2: "ImageIcon",
        3: "MusicIcon",
        4: "YoutubeIcon",
        5: "CheckIcon",
        6: "CheckSquareIcon",
        7: "ColumnsIcon",
        8: "ServerIcon",
      },
      type:'',
      dataForEdit: '',
      selectedTime:undefined
    }
  },
  created() {
    this.getCategories();
  },
  methods: {
    async addContent() {

      let intry = {
        categoryID: this.selectedCategory,
        title: this.title,
        data: JSON.stringify(this.list),
        name : this.showName,
        forTab : this.forTab
      }

      if (this.showOtherOptions === 1) {
        intry.dateType = this.selectedDate;
        intry.dateTypeTime = this.selectedTime;
      }else if(this.showOtherOptions === 2){
        intry.babyType = this.selectedBabyType;
        intry.from = this.fromTime;
        intry.to = this.toTime;
      }

      if (this.selectedCategory && this.title && this.showName) {
        const {data} = await contentRepository.create(intry);
        if (data.isSuccess) {
          await Swal.fire({
            confirmButtonText: 'ok',
            title: 'موفقیت',
            html: 'عملیات با موفقیت انجام شد',
            icon: 'success'
          });
          await this.$router.replace('/contents/list')

        } else {
          await Swal.fire('هشدار', data.message, 'warning');
        }
      } else {
        await Swal.fire('هشدار', 'لطفا مقادیر را وارد کنید', 'warning')
      }

    },
    checkCategory(){
      let category = this.categories.find(c => c.value === this.selectedCategory);

      console.log(category);

      if (category.type === 4 && category.calendarType === 1){
        this.showOtherOptions = 1;
      }else if(category.type === 4 && category.calendarType === 2) {
        this.showOtherOptions = 2;
      }else {
        this.showOtherOptions = 3;
      }


    },
    async getCategories() {
      const {data} = await categoryRepository.get({});
      if (data.isSuccess) {
        let cats = data.data.data.map(p => {
          return {
            value: p.id, text: p.title , calendarType : p.calendarType , type:p.type
          }
        });
        cats.forEach(p => {
          this.categories.push(p);
        })
      }
    },
    addSection(id) {
      this.id = id;
    },
    removeItem(index) {
      this.list.splice(index, 1)
    },
    shortTextSubmit(value) {

      console.log(value);

      this.type = 'shortText';


      this.list.push({

          name: value.name,
          content: value.content,
          type: 0

      });

      console.log(this.list)

      this.id = undefined;
    },
    longTextSubmit(value) {
      console.log(value);
      // this.type = 'longText';
      this.list.push({
          name: value.name,
          content: value.content,
          type: 1
      });
      console.log(this.list);

      this.id = undefined;
    },
    imageFormSubmit(value) {
      console.log(value);


      // this.type = 'image';

      if (value.imageAddress) {
        this.list.push(
            {

                name: value.name,
                imageAddress: value.imageAddress,
                link: value.link,
                type: 2

            }
        );
      }
      console.log(this.list);

      // console.log(this.list)
      this.id = undefined;
    },
    voiceFormSubmit(value) {
      console.log(value);

      // this.type = 'voice';

      if (value.voiceAddress) {
        this.list.push(
            {


                name: value.name,
                voiceAddress: value.voiceAddress,
                link: value.link,
                type: 3


            }
        );
      }
      console.log(this.list);

      this.id = undefined;
    },
    videoFormSubmit(value) {
      console.log(value);

      // this.type = 'video';

      this.list.push(
          {
              name: value.name,
              videoAddress: value.videoAddress,
              link: value.link,
              type: 4

          });
      console.log(this.list);

      this.id = undefined;
    },
    tapFormSubmit(value) {
      console.log(value);


      // this.type = 'tab';

      this.list.push({
          name: value.name,
          tabs: value.tabs,
        type:8
      })
      console.log(this.list);

      this.id = undefined;
    },
    sliderFormSubmit(value) {
      console.log(value);

      // this.type = 'slider';


      this.list.push({

          name: value.name,
          slides: value.slides,
          type: 7

      });
      console.log(this.list);

      this.id = undefined;
    },
    pollFormSubmit(value) {
      console.log(value);

      // this.type = 'poll';


      this.list.push(
          {

              name: value.name,
              polls: value.polls,
              questionText: value.questionText,
              questionFileAddress: value.questionFileAddress, type: 8


          });
      console.log(this.list);

      this.id = undefined;
    },
    examFormSubmit(value) {
      console.log(value);


      // this.type = 'exam';

      this.list.push(
          {

              name: value.name,
              options: value.options,
              questionText: value.questionText,
              questionFileAddress: value.questionFileAddress, type: 5

          }
      );
      console.log(this.list);

      this.id = undefined;
    },


  },
  directives: {
    Ripple,
  }
}
</script>

<style lang="scss" scoped>
.list-group-item {
  transition: all 1s
}

.ck-editor__editable {
  height: 400px !important;
}

.form-builder-card {
  min-height: 500px;
}
</style>
